import { useEffect, useState, useCallback } from "react";

// Shared PWA install state: exposes whether install is available and a trigger.
export default function useInstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [isIOS, setIsIOS] = useState(false);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) { setInstalled(true); return; }

    const ios = /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
    if (ios) setIsIOS(true);

    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => { setInstalled(true); setDeferred(null); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const promptInstall = useCallback(async () => {
    if (!deferred) return false;
    deferred.prompt();
    const choice = await deferred.userChoice;
    setDeferred(null);
    return choice && choice.outcome === "accepted";
  }, [deferred]);

  // Available if we have a native prompt (Android/desktop) or it's iOS (manual instructions), and not already installed.
  const canInstall = !installed && (!!deferred || isIOS);
  return { canInstall, isIOS, installed, hasNativePrompt: !!deferred, promptInstall };
}
